// let NnKeyConstants = (() => {

  const keyMap = {
    C: { labelNumber: "1", labelSharp: "C", labelFlat: "C", labelAccidental: "B#" },
    CsDf: { labelNumber: "2", labelSharp: "C#", labelFlat: "Db" },
    D: { labelNumber: "3", labelSharp: "D", labelFlat: "D" },
    DsEf: { labelNumber: "4", labelSharp: "D#", labelFlat: "Eb" },
    E: { labelNumber: "5", labelSharp: "E", labelFlat: "E", labelAccidental: "Fb" },
    F: { labelNumber: "6", labelSharp: "F", labelFlat: "Db", labelAccidental: "E#" },
    FsGf: { labelNumber: "7", labelSharp: "F#", labelFlat: "Gb" },
    G: { labelNumber: "8", labelSharp: "G", labelFlat: "G" },
    GsAf: { labelNumber: "9", labelSharp: "G#", labelFlat: "Ab" },
    A: { labelNumber: "10", labelSharp: "A", labelFlat: "A" },
    AsBf: { labelNumber: "11", labelSharp: "A#", labelFlat: "Bb" },
    B: { labelNumber: "12", labelSharp: "B", labelFlat: "B", labelAccidental: "Cb" },
  }

  class NnKeyConstants {

    // NnKeyConstants.keyNames is an array of the key names e.g. ['C', 'CsDf', ...]
    static get keyNames() {
      return Object.keys(keyMap);
    }

    // NnKeyConstants.keyNumbers is an array of the key numbers e.g. ['1', '2', ...]
    static get keyNumbers() {
      return NnKeyConstants.keyNames.map((k)=> {
        console.log('keyNumbers', keyMap[k])
        return keyMap[k].labelNumber;
      })  //TODO return array of numbers
    }

    // E.g. getDisplayName('CsDf', false) === '2'
    static getDisplayName(key = 'C', octave = '4', showLetter = false) {
      if (key.toLowerCase() === 'r') {
        return key;
      }
      let label = keyMap[key];
      let display = label;
      if (label) {
        display = showLetter ? label.labelSharp : label.labelNumber
      } else {
        return '--';
      }
      switch (octave) {
        case '7': return `${display}'''`;
        case '6': return `${display}"`;
        case '5': return `${display}'`;
        case '4': return `${display}`;
        case '3': return `'${display}`;
        case '2': return `"${display}`;
        case '1': return `'''${display}`;
        default: return display;
      }
    }

    static getKeyName(displayName) {
      if (displayName.toLowerCase() === 'r') {
        return 'R';
      }
      return NnKeyConstants.keyNames.find(
        k => keyMap[k].labelSharp === displayName
        || keyMap[k].labelFlat === displayName
        || keyMap[k].labelNumber === displayName
        || keyMap[k].labelAccidental === displayName
      )
    }

    static getKeyNumber(keyName)  {
      return keyMap[keyName] && keyMap[keyName].labelNumber
    }
    static get octaves() {
      return ["3", "4", "5"];
    }
  }
  // return NnKeyConstants
// })()
export default NnKeyConstants
